import { inject } from '@angular/core';
import { filter, forkJoin, Observable, Subscription, tap } from 'rxjs';
import { BeforeProcessEndEvent, isOfEventType, WizardEvent, WizardEventType } from '@mwe/features/wizard';
import { mapToUmmeldungLockRequestParams } from '../../../model/ummeldung.model';
import { UmmeldungStore } from '../ummeldung.store';

export function unlockUmmeldungBeforeProcessEndEvent(events$: Observable<WizardEvent>): Subscription {
  const store = inject(UmmeldungStore);

  return events$
    .pipe(
      filter(event => isOfEventType<BeforeProcessEndEvent>(event, WizardEventType.BeforeProcessEnd)),
      tap(event => {
        const produktdaten = store.activeUmmeldung()?.produktdaten ?? [];
        const unlockRequests$ = produktdaten.map(pd =>
          store.unlockUmmeldung(mapToUmmeldungLockRequestParams(pd.vertragsnummer, pd.zaehlpunktnummer)),
        );
        event.preventDefault(forkJoin(unlockRequests$));
      }),
    )
    .subscribe();
}
